{
  "accessDenied": "पहुंच अस्वीकृत",
  "action": "Action",
  "active": "सक्रिय",
  "address": "पता",
  "amount": "अमाउंट",
  "appName": "Exalt Exchange",
  "apply": "Apply",
  "approved": "Approved",
  "available": "उपलब्ध",
  "back": "वापस",
  "balance": "बैलेंस",
  "cancel": "Cancel",
  "cancelled": "Cancelled",
  "cardProviderRequired": "प्रदाता एकीकरण आवश्यक है",
  "cardProviderRequiredDescription": "EXALT कार्ड अभी उपलब्ध नहीं है। इस सुविधा का उपयोग करने से पहले एक वास्तविक कार्ड-जारीकर्ता प्रदाता को कनेक्ट किया जाना चाहिए।",
  "close": "बंद करें",
  "closed": "बंद",
  "coin": "Coin",
  "comingSoon": "जल्द आ रहा है",
  "completed": "Completed",
  "confirm": "पुष्टि करें",
  "continue": "जारी रखें",
  "copy": "कॉपी करें",
  "copyFailed": "कॉपी विफल रहा।",
  "copyright": "सर्वाधिकार सुरक्षित।",
  "country": "Country",
  "currency": "मुद्रा",
  "date": "Date",
  "delete": "Delete",
  "description": "Description",
  "details": "विवरण",
  "disabled": "अक्षम",
  "download": "डाउनलोड करें",
  "edit": "संपादित करें",
  "email": "ईमेल",
  "enabled": "सक्रिय",
  "error": "त्रुटि",
  "exaltCard": "EXALT कार्ड",
  "exchange": "एक्सचेंज",
  "failed": "Failed",
  "fast": "तेज़",
  "fillAllRequiredFields": "सभी आवश्यक जानकारी भरें।",
  "gated": "सीमित",
  "global": "Global",
  "inactive": "निष्क्रिय",
  "information": "जानकारी",
  "invalidRequest": "अमान्य अनुरोध।",
  "language": "भाषा",
  "languagePreferences": "भाषा प्राथमिकताएँ",
  "loading": "लोड हो रहा है...",
  "locked": "Locked",
  "lockedBalance": "लॉक्ड बैलेंस",
  "name": "नाम",
  "network": "नेटवर्क",
  "networkError": "नेटवर्क त्रुटि।",
  "next": "अगला",
  "no": "No",
  "noAssetsFound": "कोई संपत्ति नहीं मिली।",
  "noDataFound": "कोई डेटा नहीं मिला।",
  "noResultsFound": "कोई परिणाम नहीं मिला।",
  "noRewardsYet": "अभी तक कोई रिवॉर्ड नहीं।",
  "noRewardsYetDescription": "वास्तविक रेफरल और स्टेकिंग रिवॉर्ड कमाने पर यहां दिखाई देंगे।",
  "notAvailable": "उपलब्ध नहीं",
  "notVerified": "सत्यापित नहीं",
  "note": "Note",
  "notificationCenter": "सूचनाएं",
  "open": "Open",
  "openStatus": "खुला",
  "pending": "Pending",
  "permissionRequired": "आपको यह कार्रवाई करने की अनुमति नहीं है।",
  "phone": "फ़ोन",
  "pleaseLoginFirst": "कृपया पहले लॉगिन करें।",
  "price": "कीमत",
  "processing": "प्रोसेसिंग...",
  "reference": "संदर्भ",
  "referralProgram": "रेफरल",
  "refresh": "रिफ्रेश",
  "refreshing": "रिफ्रेश हो रहा है...",
  "rejected": "Rejected",
  "remove": "हटाएं",
  "requestFailed": "अनुरोध विफल रहा।",
  "rewardsCenter": "रिवॉर्ड्स सेंटर",
  "rewardsUnavailable": "अभी आपके रिवॉर्ड लोड नहीं हो सके।",
  "role": "भूमिका",
  "save": "सहेजें",
  "saving": "सहेजा जा रहा है...",
  "search": "खोजें",
  "searchAssets": "संपत्ति खोजें",
  "secure": "सुरक्षित",
  "sending": "भेजा जा रहा है...",
  "serverError": "सर्वर त्रुटि।",
  "servicesHub": "सेवाएं",
  "sessionExpired": "सत्र समाप्त हो गया। कृपया पुनः लॉगिन करें।",
  "spot": "स्पॉट",
  "status": "स्टेटस",
  "submit": "सबमिट करें",
  "submitting": "Submitting...",
  "success": "Success",
  "system": "सिस्टम",
  "time": "समय",
  "token": "टोकन",
  "total": "Total",
  "transactionHash": "लेनदेन हैश",
  "type": "प्रकार",
  "uid": "यूआईडी",
  "unauthorized": "अनधिकृत",
  "unlocked": "Unlocked",
  "update": "अपडेट करें",
  "upload": "अपलोड करें",
  "user": "User",
  "userId": "यूज़र आईडी",
  "value": "मूल्य",
  "verified": "Verified",
  "view": "देखें",
  "viewAllNotifications": "सभी सूचनाएं देखें",
  "wallet": "Wallet",
  "walletAddress": "वॉलेट एड्रेस",
  "warning": "चेतावनी",
  "yes": "Yes"
}